<template>
    <div>
      <div class="header">
            <div>
              <img style="width:.26rem;height: .26rem;margin: 0 .1rem 0 .16rem;" src="../assets/img/logo_Lan.svg">
              <img style="width:1.96rem;height: .23rem;" src="../assets/img/wenzi_lan.svg" >
            </div>
            <!-- <img style="width:.22rem;height: .22rem;margin: 0 .22rem 0 .46rem;" src="../assets/img/fangdajing_lan.svg" > -->
            <img style="width:.22rem;height: .18rem;margin-left: .9rem" src="../assets/img/cuohao_lan.svg"  @click="close">
      </div>
    </div>
</template>

<script>

export default {
    data() {
       return {

       }
    },
  methods: {
    close () {
        this.$emit('onClose')
      }
    },
    created() {

    },
}
</script>

<style scoped>
   .header{
      display: flex;
      align-items: center;
      position: absolute;
      z-index: 999;
      top: 0;
      left: 0;
      width: 100%;
      height: .51rem;
      background: white;
    }
</style>